import AdminView from "@/pages/ambassadors/admin-view";
import UserView from "@/pages/ambassadors/user-view";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionsEnum, PermissionLevel } from "@/modules/common/types";

export default function AmbassadorsPage() {
  return (
    <PermissionGuard
      permissions={[
        {
          name: PermissionsEnum.ADMIN_VIEW_AMBASSADORS,
          level: PermissionLevel.READ,
        },
      ]}
      ifNotAllowed={<UserView />}
    >
      <AdminView />
    </PermissionGuard>
  );
}
